module.exports = __webpack_public_path__ + "media/src/img/nd_qr_sbp-17ece885e90f4f2b4cf0a1c54b2f70f0.png";